<template>
  <div class="footer-wrapper">
    <img class="img-top" :src="textData.img1"/>
    <!-- <div class="top-title">蓝智与您共启认知与决策智能新篇章</div> -->
    <div class="top-title">蓝智愿与您科技赋能、共享科技文明！</div>
    <div class="top">
      <div class="left">
        <div class="logo">
          <img :src="textData.img2"/>
        </div>
        <div class="qr-info">
          <div class="img">
            <img class="image-size" :src="textData.img3">
          </div>
          <div class="info">
            <div class="child">
              <div>{{textData.address}}</div>
              <div>{{textData.phone}}</div>
              <div>{{textData.mail}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="menu-child" v-for="(menu, index) in menuList" :key="index">
          <h2 class="title">{{menu.title}}</h2>
          <div class="content" v-for="(child, childIndex) in menu.childList" :key="childIndex">
<!--            <el-link :underline="false" :href="child.route">{{child.title}}</el-link>-->
            <el-button type="text" @click="routerTo(child.route)">{{child.title}}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="down">
      <el-divider></el-divider>
      <div>{{textData.filings1}}</div>
      <div>{{textData.filings2}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      menuList: [],
      textData: {}
    }
  },
  methods: {
    routerTo (route) {
      this.$router.push({
        path: route,
        query: ''
      })
    }
  },
  mounted: function () {
    if (this.$boss) {
      this.textData = this.$boss.page001.g001[0]
      // this.contentData = this.$boss.page162.g162 || []
      const menus = this.$boss.page999.g999
      let parentList = menus.filter(item => !item.parent)
      let childList = menus.filter(item => item.parent)
      this.menuList = parentList.map(p => {
        p.childList = childList.filter(it => it.parent === p.title)
        return p
      })
    }
  }
}
</script>
<style scoped lang="less">
  @media screen and (min-width: 1901px) {
    .footer-wrapper {
      width: 100%;
      height: 100vh;
      position:relative;
      background-color: #fbfbfb;
      .top-title {
        font-size: 48px;
        margin-bottom: 15px;
        line-height: 60px;
        max-height: 120px;
        font-weight: bold;
        color: #fff;
        position: absolute;
        left: 100px;
        top: 10%;
      }
      .img-top {
        height: 40vh;
        width: 100%;
      }
      .top {
        height: 36vh;
        width: 100%;
        .left {
          float: left;
          width: calc(50% - 100px);
          height: 100%;
          margin-left: 100px;
          .logo {
            width: 100%;
            text-align: left;
            margin-top:5%;
          }
          .qr-info {
            width: 100%;
            display: flex;
            margin-top:10%;
            .img{
              img {
                width: 120px;
                height: 120px;
              }
            }
            .info {
              width: 80%;
              div {
                padding: 0 15px 20px;
                font-size: 20px;
                color: #323232;
                /*width: 100%;*/
                text-align: left;
              }
            }
          }
        }
        .right {
          float: right;
          width: 50%;
          height: 100%;
          /*justify-content: space-between;*/
          display: flex;
          /*background: #13ce66;*/
          .menu-child{
            /*padding-top: 1%;*/
            padding-left: 20px;
            width: 150px;
            /*background: #2EB8DC;*/
            text-align: left;
            h2 {
              font-size: 24px;
              padding-bottom: 10px;
              font-weight: 500;
              color: #323232;
            }
            div .el-button{
              font-size: 20px;
              color: #6d6d6d;
              padding: 10px 0;
            }
          }
        }
      }
      .down {
        position: absolute;
        bottom: 8vh;
        width: 100%;
        div {
          font-size: 18px;
          color: #919191;
          /*padding: 0 10px;*/
        }
      }

    }
  }
  @media screen and (max-width: 1900px) {
    .footer-wrapper {
      width: 100%;
      height: 100vh;
      position:relative;
      background-color: #fbfbfb;
      .top-title {
        font-size: 36px;
        margin-bottom: 15px;
        line-height: 60px;
        max-height: 120px;
        font-weight: bold;
        color: #fff;
        position: absolute;
        left: 100px;
        top: 10%;
      }
      .img-top {
        height: 30vh;
        width: 100%;
      }
      .top {
        position: fixed;
        height: calc(70vh - 80px);
        width: 100%;
        .left {
          float: left;
          width: 50%;
          height: 100%;
          .logo {
            position: absolute;
            left: 100px;
            top:10%
          }
          .qr-info {
            width: 100%;
            position: absolute;
            left: 100px;
            top:35%;
            display: flex;
            .img{
              img {
                width: 120px;
                height: 120px;
              }
            }
            .info {
              width: 80%;
              div {
                padding: 0 20px 28px;
                font-size: 16px;
                color: #999aaa;
                /*width: 100%;*/
                text-align: left;
              }
            }
          }
        }
        .right {
          float: right;
          width: 50%;
          height: 100%;
          /*justify-content: space-between;*/
          display: flex;
          /*background: #13ce66;*/
          .menu-child{
            padding-top: 2%;
            padding-left: 20px;
            width: 150px;
            /*background: #2EB8DC;*/
            text-align: left;
            h2 {
              font-size: 16px;
              padding-bottom: 10px;
            }
            div .el-button{
              font-size: 16px;
              color: #5e5e5e;
              padding: 5px 0;
            }
          }
        }
      }
      .down {
        position: absolute;
        bottom: 80px;
        width: 100%;
        p {
          font-size: 22px;
          color: #919191;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/footer.vue